import { createSelector } from 'reselect'
import { isSpoofed } from 'selectors/isSpoofed'
import isPassportCardInsurancePostPurchaseEnabled from 'selectors/isPassportCardInsurancePostPurchaseEnabled'
import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'
import { isPassportCardStartDateWithinAllowedRange } from 'checkout/Components/CheckoutSteps/Review/PassportCardInsurance/passportCardUtils'
import getInsuranceDatesFromCart from './getInsuranceDatesFromCart'
import { hasPassportCardEligibleItems } from '../view/itemViews/getPassportCardQuoteItems'

const isPassportCardInsuranceSupportedSpoofed = createSelector(
  (state: App.State) => state.geo.currentRegionCode,
  (state: App.State) => isSpoofed(state),
  (state: App.State) => getInsuranceDatesFromCart(state)?.startDate,
  (state: App.State) => hasPassportCardEligibleItems(state),
  (state: App.State) => findPostPurchaseCheckout(state.checkout.cart.mode),
  (state: App.State) => !!state.checkout.cart.existingOrder,
  (state: App.State) => isPassportCardInsurancePostPurchaseEnabled(state),
  (
    regionCode,
    spoofed,
    checkoutStartDate,
    cartHasEligibleItems,
    postPurchase,
    hasExistingOrder,
    isEnabledForExistingOrder,
  ): boolean => {
    if (regionCode !== 'AU') return false
    if (!spoofed) return false
    // A post-purchase insurance cart carries no trip items of its own, so the existing
    // order decides: every vertical PassportCard can quote is offered to agents.
    if (postPurchase === 'insurance' && hasExistingOrder) return isEnabledForExistingOrder
    if (!isPassportCardStartDateWithinAllowedRange(checkoutStartDate)) return false
    return cartHasEligibleItems
  },
)

export default isPassportCardInsuranceSupportedSpoofed
